/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MessageBannerCarousel_messages$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageBanner_viewer$ref: FragmentReference;
export type MessageBanner_viewer = {|
  +unregisteredUserMessages?: ?$ReadOnlyArray<?{|
    +$fragmentRefs: MessageBannerCarousel_messages$ref
  |}>,
  +previewMessages?: ?$ReadOnlyArray<?{|
    +$fragmentRefs: MessageBannerCarousel_messages$ref
  |}>,
  +$refType: MessageBanner_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "FragmentSpread",
    "name": "MessageBannerCarousel_messages",
    "args": null
  }
];
return {
  "kind": "Fragment",
  "name": "MessageBanner_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "marketingBannerIsFirstTimeVisitor",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "marketingBannerPreviewSetId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "marketingBannerPreviewUserType",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "hasMarketingBannerPreviewVariables",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasMarketingBannerPreviewVariables",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "previewMessages",
          "name": "messageSet",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "setId",
              "variableName": "marketingBannerPreviewSetId",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "userType",
              "variableName": "marketingBannerPreviewUserType",
              "type": "String"
            }
          ],
          "concreteType": "MessageSetModule",
          "plural": true,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "Condition",
          "passingValue": false,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": "unregisteredUserMessages",
              "name": "messageSet",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "isFirstTimeVisitor",
                  "variableName": "marketingBannerIsFirstTimeVisitor",
                  "type": "Boolean"
                }
              ],
              "concreteType": "MessageSetModule",
              "plural": true,
              "selections": (v0/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '126ffb553844df86658da81e74c6f08f';
module.exports = node;
